// start:ng42.barrel
export * from './app-actions.delegate';
export * from './cancel-reservation.delegate';
export * from './modify-reservation.delegate';
export * from './manage-stay.delegate';
export * from './modify-account.delegate';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/delegates/index.ts